import React, { useState, forwardRef } from 'react';
import { HelpCircle } from "lucide-react";

import '../css/ChatSidebar.css';
import '../css/Common.css';
import ChatHistoryList from './ChatHistoryList';
import CloseSidebarBtn from './CloseSidebarBtn';

const ChatSidebar = forwardRef(({ onChatSelect, closeSidebarClick, onDeleteChat, onTitleChange, chats, showMenu }, ref) => {
    const [selectedChatId, setSelectedChatId] = useState(null);

    const handleNewChat = () => {
        setSelectedChatId(null);
        onChatSelect(null);
    };

    return (
        <div ref={ref} className={`chat-sidebar ${showMenu ? '!flex' : ''}`}>
            <CloseSidebarBtn onClick={closeSidebarClick} />
            <div id="title">Insight Note<span className="add-small"></span></div>
            <div className="top-fixed">
                <div id="how-to-use-area">
                    <a id="a-how-to-use" href="/how-to-use/">
                        <div className="new-chat-container">
                            <div className="img-item">
                                <HelpCircle color="white"/>
                            </div>
                            <div className="title-item">
                                <span>使い方</span>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
            <div id="new-chat-div">
                <ul id="new-chat-ul">
                    <li id="new-chat" onClick={handleNewChat}>＋ New Chat</li>
                </ul>
            </div>
            <ChatHistoryList
                onChatSelect={onChatSelect}
                selectedChatId={selectedChatId}
                setSelectedChatId={setSelectedChatId}
                onDeleteChat={onDeleteChat}
                onTitleChange={onTitleChange}
                chats={chats}
            />
        </div>
    );
});

export default ChatSidebar;
